import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Experience from "../components/Experience";
import Publications from "../components/Publications";

const Home = () => (
  <>
    <Hero />
    <About />
    <Experience />
    <Publications />
  </>
);

export default Home;
